import { useEffect, useState } from "react";

import { SelectAgentAndVersion } from "src/agentNode/components/agentSelectionModal/SelectAgentAndVersion";
import { Button } from "src/base-components/Button";
import { Agent, AgentVersion } from "src/clients/agent-management";
import { Modal } from "src/design-system/Modal";

type Props = {
  open: boolean;
  handleClose: () => void;
  handleSubmit: (version: AgentVersion, agent: Agent) => void;
};

export const AgentSelectionModal: React.FC<Props> = ({
  open,
  handleClose,
  handleSubmit,
}) => {
  const [selectedAgent, setSelectedAgent] = useState<Agent | null>(null);
  const [selectedVersion, setSelectedVersion] = useState<AgentVersion | null>(
    null,
  );

  // Reset the modal state upon reopening
  useEffect(() => {
    if (open) {
      setSelectedAgent(null);
      setSelectedVersion(null);
    }
  }, [open]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Modal.Header>Select an Agent and version</Modal.Header>
      <Modal.Content>
        <div className="flex h-[540px] flex-col">
          <SelectAgentAndVersion
            selectedAgent={selectedAgent}
            selectedVersionId={selectedVersion?.id}
            onAgentSelect={setSelectedAgent}
            onVersionSelect={setSelectedVersion}
          />
        </div>
      </Modal.Content>
      <Modal.Footer
        primaryButton={
          <Button
            dataLoc="agent-selection-submit"
            disabled={selectedAgent === null || selectedVersion === null}
            onClick={() => {
              if (selectedVersion && selectedAgent) {
                handleSubmit(selectedVersion, selectedAgent);
                handleClose();
              }
            }}
          >
            Select an Agent and version
          </Button>
        }
      />
    </Modal>
  );
};
